import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase} from "@mui/material";
import TableUserList from "../../components/TableUserList";
import {useEffect, useState, useRef} from 'react';
import axios from 'axios';
import {API_ENDPOINT_URL} from "../../util/api";
import { getLocalItem } from "../../util/helper";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash'; 

const timezone = 'Asia/Tokyo';

const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      cellClassName: "name-column--cell"
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1
    },
    {
      field: "is_active",
      headerName: "Active",
      flex: 1
    },
    {
      field: "is_staff",
      headerName: "Staff",
      flex: 1
    },
    {
      field: "is_admin",
      headerName: "Superuser",
      flex: 1
    },
    {
      field: "created",
      headerName: "Created",
      flex: 1
    },
  ];

const UserList = () => {
  const [loading, setLoading]= useState(false)
  const navigate = useNavigate();
  const token = getLocalItem("key")
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParam, setSearchParam] = useState({ordering: 'id',});

  const [data, setData] = useState([]);

  const handleSearch = (searchParamsVar) => {
    const { searchText, currentPageChange, sort } = searchParamsVar;
    setCurrentPage(currentPageChange)
    setSearchParam({
      page: currentPageChange,
      ordering: "id",
      search: searchText,
    });
  };

  const handleNewUserClick = () => {
    // Redirect to the "add-user" page
    setTimeout(() => {
      navigate("/user-add");
    }, 500);
  };

  useEffect(() => {
    setLoading(true)
    axios.get(`${API_ENDPOINT_URL}/user-list/`, { params: {...searchParam }, headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          setData(response.data);
        })
        .catch(error => {})
        .finally(() => setLoading(false));
  }, [searchParam]);

  
  return (
    <Box
      mt="50px"
      sx={{
        width: "95%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Grid container spacing={0}>
        <Grid item lg={6} sm={12} md={6}>
          <Box>
            <Typography
              variant="h1"
              fontSize={40}
              fontWeight="bold"
              color="#2699fb"
              textAlign="left"
            >
              User list
            </Typography>
          </Box>
          
        </Grid>
        <Grid container spacing={2} sx={{ justifyContent: 'flex-end' }}>
          <Grid item xs={2}>
            <Typography
              onClick={handleNewUserClick}
              sx={{
                borderRadius: "30px",
                padding: "9px 16px 9px 16px",
                backgroundColor: "#2699fb",
                color: "white",
                fontWeight: "bold",
                fontSize: "17px",
                cursor: "pointer",
                alignItems: 'center',
              }}
            >
              New User <AddIcon sx={{fontSize: 30, marginBottom: '-10px'}}/>
            </Typography>
          </Grid>
        </Grid>
          
        </Grid>
        {data ? (
          <Box width="100%">
            <TableUserList
              rows={data.results}
              columns={columns}
              totalPage={data.last_page_number}
              onSearch={handleSearch}
              loading={loading}
              currentPage={currentPage}
            />
          </Box>
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
    // </ThemeProvider>
  );
};

export default UserList;
